<template>
  <div>
    <h1 class="common__main-title">Add Schedule</h1>
    <div class="common__sub-title">
      <span>Add</span>
    </div>
    <TutorInfo :tutor="tutor"/>
    <div class="content-wrapper">
      <ConfirmForm :schedule="schedule"/>
      <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{
            name:'AddSchedule',
            params: { editingSchedule: this.$route.params.editingSchedule }
          }"
        >
          Back
        </b-button>
        <b-button
          pill
          variant="primary"
          @click="create"
        >
          Register
        </b-button>
      </div>
    </div>
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import TutorInfo from '@/components/parts/TutorInfo.vue';
import ConfirmForm from '@/components/parts/schedules/ConfirmForm.vue'
import { Tutor } from '@/store/tutors/types'
import { Schedule } from '@/store/schedules/types'
import Loading from '@/components/parts/modal/Loading.vue'

export default Vue.extend({
  components: {
    TutorInfo,
    ConfirmForm,
    Loading,
  },

  data() {
    return {
      isLoading: false,
    }
  },

  computed: {
    schedule(): Schedule {
      const schedule: Schedule = JSON.parse(this.$route.params.editingSchedule)
      return {
        ...schedule,
        date: moment(schedule.date),
        from: moment(schedule.from),
        to: moment(schedule.to),
      }
    },
    tutor(): Tutor {
      const tutor: Tutor = JSON.parse(this.$route.params.tutor)
      return {
        ...tutor,
        hireDate: moment(tutor.hireDate),
      }
    },
  },

  methods: {
    async create() {
      if (this.isLoading) {
        return
      }
      this.isLoading = true

      try {
        const result = await this.$store.dispatch('registerSchedule', {
          tutorId: this.tutor.id,
          schedule: this.schedule,
        })
        this.isLoading = false
        await this.$bvModal.msgBoxOk('Success !')

        this.$router.push({
          name: 'TimesheetDetail',
          params: { tutorId: this.tutor.id },
        })
      } catch (error: any) {
        const message = error.response?.data?.message || error
        this.isLoading = false
        await this.$bvModal.msgBoxOk(`Error - ${message}`)
        this.$router.push({
          name: 'AddSchedule',
          params: {
            tutorId: this.tutor.id,
            editingSchedule: this.$route.params.editingSchedule,
          },
        })
      }
    },
  },
})
</script>

<style scoped>
.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
}
</style>
